export default function () {
  return function (p) {
    let data = null;
    let lastW;

    p.setup = function () {
      p.frameRate(12);
      p.createCanvas(300, 180);
      p.noLoop();
    };

    p.draw = function () {
      p.clear();
      if (data?.l?.width) {
        const isLeft = p.frameCount % 2;
        const previewWidth = p.min(240, data.l.width);
        const previewHeight = (data.l.height / data.l.width) * previewWidth;
        const size = data.showFlicker ? previewWidth : previewWidth * 2 + 10;

        // handle resize
        if (previewWidth != lastW) {
          p.resizeCanvas(size, previewHeight);
          lastW = previewWidth;
        }

        if (data.showFlicker) {
          // Draw flicker preview
          p.image(isLeft ? data.l : data.r, 0, 0, previewWidth, previewHeight);
        } else {
          // draw side-by-side
          p.image(data.l, 0, 0, previewWidth, previewHeight);
          p.image(data.r, previewWidth + 10, 0, previewWidth, previewHeight);
        }
      }
    };

    /**
     * Handle updates from the Vue.js data
     * @param  {Object} _data The passed-in parameters
     */
    p.dataChanged = function (_data) {
      data = _data;
      lastW = null;
      if (data.showFlicker) {
        p.loop();
      } else {
        p.noLoop();
        p.redraw();
      }
    };
  };
}
